import * as z from "zod/v4";

export const updateAeoPromptTag = {
  name: "updateAeoPromptTag" as const,
  input: z.object({
    tagId: z.bigint(),
    name: z.string().optional(),
    color: z.string().nullable().optional(),
  }),
  output: z.object({ updated: z.boolean() }),
};
